import script from "./HeaderPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderPrimary.vue?vue&type=script&setup=true&lang=js"

import "./HeaderPrimary.vue?vue&type=style&index=0&id=35fffaf4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/wp-content/themes/stewartrealtor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35fffaf4"]])

export default __exports__